import script from "./GeneListCard.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneListCard.vue?vue&type=script&setup=true&lang=js"

import "./GeneListCard.vue?vue&type=style&index=0&id=d3cbde6a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3cbde6a"]])

export default __exports__